<script lang="ts">
    import { Dialog, Modal } from 'attractions';

    export let open: boolean;
</script>

<Modal bind:open let:closeCallback>
    <Dialog title="Sukces" {closeCallback}>
        <section class="successAddedPurchase">
            <img src="assets/success.gif" alt="">
            <h3>Pomyślnie dodaliśmy zakup do Twojego konta.</h3>
        </section>
    </Dialog>
</Modal>

<style type="text/scss">
    .successAddedPurchase {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
            height: 75px;
            margin: 1rem 0 2rem 0;
        }
    }
</style>